import { Round } from "./round"
import { AIPlayer } from "./ai-player"
import { EnergySource } from "./energy-source"
import { Inventory } from "./inventory"
import { NotificationItem } from "./notification"
import { History } from "./history"

export class Game {
    public rounds: Round[] | null
    public aiPlayers: AIPlayer[]
    public energySources: EnergySource[]
    public activeRound: number
    public popup: boolean
    public roundActive: boolean
    public selectedEnergySource: EnergySource | null
    public playerEnergy: number
    public inventory: Inventory
    public history: History
    public timeVal: number
    public timeStr: string
    public minsSinceMidnight: number
    public roundSpeed: number
    public paused: boolean
    public money: number
    public notifications: NotificationItem[]
    public minMwatts: number | null
    public playerLost: boolean
    public gameOver: boolean
    public pollutionThreshold: number
    public pollution: number
    public muted: boolean
    public daysPerRound: number
    public totalDays: number
    public introScreen: boolean
    public showBook: boolean
    public firstLoad: boolean
    public tutorial: boolean
    public showOverview: boolean
    public tutorialIndex: number
    constructor(
        aiPlayers: AIPlayer[],
        energySources: EnergySource[],
        roundSpeed: number,
        money: number,
        pollutionThreshold: number,
        daysPerRound: number
    ) {
        // this property will need to be set asynchronously
        this.rounds = null
        this.introScreen = true
        this.aiPlayers = aiPlayers
        this.energySources = energySources
        this.activeRound = 1
        this.popup = false
        this.selectedEnergySource = null
        this.playerEnergy = 0
        this.roundActive = false
        this.history = new History()
        this.inventory = new Inventory()
        this.timeVal = 0
        this.minsSinceMidnight = 0
        this.timeStr = ""
        this.roundSpeed = roundSpeed
        this.paused = false
        this.money = money
        this.notifications = []
        this.minMwatts = null
        this.playerLost = false
        this.gameOver = false
        this.pollutionThreshold = pollutionThreshold
        this.pollution = 0
        this.daysPerRound = daysPerRound
        this.totalDays = 0
        this.muted = false
        this.showBook = false
        this.firstLoad = true
        this.tutorial = false
        this.showOverview = false
        this.tutorialIndex = 0
    }
}
